import React from 'react';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CardBody from '../../shared/components/CardBody';
import Paginator from '../../shared/components/Paginator';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import ContractorsTable from './ContractorsTable';
import { ContractorsRequest } from '../ws/ContractorsRequest';
import Alert from 'react-s-alert';

const ContractorsStates = {
    ALL: 'ALL',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};

export class ContractorsCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            contractors: [],
            contractorsPage: 1,
            contractorsState: ContractorsStates.ALL,
            contractorsSearch: '',
            contractorsLoading: false,
        };
    }

    componentDidMount() {
        this.handleFetchContractors();
    }

    componentDidUpdate(prevProps, prevState) {
        const refresh = prevState.contractorsSearch !== this.state.contractorsSearch
            || prevState.contractorsState !== this.state.contractorsState
            || prevState.contractorsPage !== this.state.contractorsPage;

        if ( refresh ) this.handleFetchContractors();
    }

    render() {
        const {
            contractors,
            contractorsLoading,
            contractorsPagination,
        } = this.state;

        return (
            <Row clearfix>
                <Card loading={contractorsLoading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODOS_LOS_CONTRATISTAS').toUpperCase()}
                        subtitle={this.handleSubtitle()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody>
                        <ContractorsTable
                            contractors={contractors}
                            loading={contractorsLoading}
                        />
                        <Paginator
                            data={contractorsPagination}
                            onPage={this.handlePage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

    renderHeaderOptions() {
        const {
            contractorsState,
            contractorsSearch,
        } = this.state;

        const filterOptions = [
            {
                title: I18nUtils.tr('TR_TODOS'),
                active: contractorsState === ContractorsStates.ALL,
                onClick: () => this.setState({ contractorsState: ContractorsStates.ALL }),
            },
            {
                title: I18nUtils.tr('TR_ACTIVOS'),
                active: contractorsState === ContractorsStates.ACTIVE,
                onClick: () => this.setState({ contractorsState: ContractorsStates.ACTIVE }),
            },
            {
                title: I18nUtils.tr('TR_INACTIVOS'),
                active: contractorsState === ContractorsStates.INACTIVE,
                onClick: () => this.setState({ contractorsState: ContractorsStates.INACTIVE }),
            },
        ];

        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.handleFetchContractors}
                onSearch={this.handleSearch}
                searchText={contractorsSearch}
                filterOptions={filterOptions}
            />
        );
    }

    handlePage = (contractorsPage) => {
        this.setState({ contractorsPage });
    };

    handleSearch = (contractorsSearch) => {
        this.setState({ contractorsSearch, contractorsPage: 1 });
    };

    handleFetchContractors = () => {
        const {
            contractorsPage,
            contractorsSearch,
            contractorsState,
        } = this.state;

        const criteria = {
            term: contractorsSearch,
            page: contractorsPage,
            only_active: contractorsState === ContractorsStates.ACTIVE,
            only_inactive: contractorsState === ContractorsStates.INACTIVE,
            show_only_deleted: false,
        };

        new ContractorsRequest({ criteria })
            .onPreExecution(() => this.setState({ contractorsLoading: true }))
            .onSuccess((res) => this.setState({ contractors: res.data, contractorsPagination: res.pagination }))
            .onFail((error) => Alert.error(error || I18nUtils.tr('TR_ERROR_OBTENER_CONTRATISTAS')))
            .onPostExecution(() => this.setState({ contractorsLoading: false }))
            .execute();
    };

    handleSubtitle = () => {
        switch ( this.state.contractorsState ) {
            case ContractorsStates.ALL:
                return I18nUtils.tr('TR_TODOS');
            case ContractorsStates.ACTIVE:
                return I18nUtils.tr('TR_ACTIVOS');
            case ContractorsStates.INACTIVE:
                return I18nUtils.tr('TR_INACTIVOS');
            default:
        }
    };

}



// WEBPACK FOOTER //
// ./src/app/contractors/components/ContractorsCard.js